module.exports = __webpack_public_path__ + "img/content.6c95fa53.png";